// extracted by mini-css-extract-plugin
export default {"container":"J0-z","heading":"K0-z","links":"L0-z","copy":"M0-z","subCopy":"N0-z","linksLeft":"O0-z","linksCenter":"P0-z","linksRight":"Q0-z","link":"R0-z","onlyLink":"S0-z"};